export const AUTH_ATOM_KEY = "SpearlyAccount"

export const HIDDEN_HEADER_PATH = [
  "/",
  "/signup",
  "/login",
  "/figma_callback",
  "/github_callback",
  "/login/callback",
  "/password/reset",
  "/password/confirmation",
]

export class UserRole {
  static readonly OWNER = "owner"
  static readonly ADMIN = "admin"
  static readonly DEVELOPER = "developer"
  static readonly EDITOR = "editor"
  static readonly WRITER = "writer"
}

export const PlanTypeMap = {
  FREE: "free",
  STARTER: "starter",
  BASIC: "basic",
  PROFESSIONAL: "professional",
  ENTERPRISE: "enterprise",
} as const

// プランの安い順。プラン一覧の並び順（actions/plan.ts の loadPlans）と、
// アップグレード / ダウングレードの判定（hooks/usePlan.ts の isUpgrade）が
// この 1 本を見る。2 つに分けて持つと片方だけ古くなる: 実際に starter が
// どちらにも入っておらず、CLOUD の starter がプラン一覧から丸ごと消え、
// free -> starter（¥0 -> ¥1,500）が indexOf === -1 のせいで
// 「ダウングレード」として描かれていた。
// starter は案C（auth-api config/plans.yml の v4 cloud）で増えたプランで、
// CMS には無い。サービスごとの有無は「subscription に価格があるか」で
// 決まる（helpers/planHelpers.ts の planDeserializer）ので、ここは
// 全サービス分の順序だけを持つ。
export const PLAN_TYPE_ORDER = [
  PlanTypeMap.FREE,
  PlanTypeMap.STARTER,
  PlanTypeMap.BASIC,
  PlanTypeMap.PROFESSIONAL,
  PlanTypeMap.ENTERPRISE,
] as const

export const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
] as const
